<form 
    (ngSubmit)="$event.preventDefault(); saveAssignedUser();"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Record of Assigned Responsibilities (ROAR)
        </h2>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 

            <div class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>User Assigned to this ROAR: *</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div class="w-full flex items-start gap-2 text-sm">
                        <select 
                            id="member" 
                            class="border border-nside-gray-300 font-medium rounded-md focus:ring-nside-gray-300 focus:border-nside-gray-300 block w-full p-2.5"
                            [(ngModel)]="selectedMemberId" 
                            name="member"
                            (change)="onMemberChange($event)"
                        >
                            <option *ngFor="let member of threatTeam" [value]="member.user_id">
                                {{ member.name }} - {{ member.email }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !this.selectedMemberId,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.selectedMemberId
                }"
                [disabled]="!this.selectedMemberId"
            >
                Save
            </button>
        </div>
    </div>
</form>

<div *ngIf="loading">
    <spinner></spinner>
</div>